
import React, { useState, useEffect, } from 'react';

import {
  Typography, Box,} from '@mui/material';

import ProjectMenu from './ProjectMenu';
import AvatarGroup from './AvatarGroup';


const ProjectsCard = ({ projects, children, index, ...other }) => {

  const [loading, setLoading] = useState(true);
  const [selectedValues, setSelectedValues] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);

  useEffect(() => {
    const timer = setTimeout(() => setLoading(false), 1000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <>
      <div className="row gy-0">
        <div className="col-xxl-12 d-flex flex-wrap gap-2">
          {projects.map((project, index) => (
            <div
              key={index}
              className="card-body p-20 bg-base border d-flex flex-column justify-content-center rounded-3"
              style={{ flex: '1 1 300px', minWidth: '300px' }}
            >
              <a href="/project-details" style={{ textDecoration: 'none', color: 'inherit' }}>
              <Box display="flex" justifyContent="space-between" alignContent="flex-start">
                <Box display="flex" alignContent="center" sx={{ gap: 2 }}>
                  <Box
                    sx={{
                      height: '72px',
                      minWidth: '72px',
                      backgroundColor: project.bgColor,
                      fontSize: '40px',
                      color: '#FFFFFF',
                      fontWeight: '700',
                      textAlign: 'center',
                      lineHeight: '72px',
                      fontFamily: 'Manrope',
                    }}
                  >
                    {project.letter}
                  </Box>
                  <Box>
                    <Typography sx={{ fontSize: '16px', fontWeight: '600', color: '#373737', fontFamily: 'Manrope', textOverflow:'ellipsis', whiteSpace:'nowrap', overflow:'hidden', maxWidth: '150px' }}>
                      {project.title}
                    </Typography>
                    <span
                      style={{
                        fontSize: 12,
                        color: project.statusColor,
                        backgroundColor: project.statusBg,
                        borderRadius: '100px',
                        fontWeight: 600,
                        display: 'inline-block',
                        padding: '2px 12px',
                        margin: '0 0 4px',
                        fontFamily: 'Manrope',
                        height: '18px',
                        lineHeight:'1.1',
                      }}
                    >
                      {project.status}
                    </span>
                    <Typography sx={{ fontSize: '12px', fontWeight: '400', color: '#9095A1', fontFamily: 'Manrope' }}>
                      Created: {project.time}
                    </Typography>
                  </Box>
                </Box>
                <Box sx={{ display: 'flex' , justifyContent: 'center' , alignItems: 'center' ,  textAlign: 'center', background: '#fff', borderRadius: '6px', color: '#1A1F36', fontSize: '16px', textTransform: 'capitalize', width: '34px', minWidth: '34px', height: '34px', border: '1px solid #D0D5DD', }}>
                  <ProjectMenu />
                </Box>
              </Box>

              <Typography
                sx={{
                  fontSize: '12px',
                  fontWeight: '500',
                  color: '#606060',
                  margin: '24px 0',
                  lineHeight: '1.4',
                  fontFamily: 'Manrope',
                }}
              >
                {project.description}
              </Typography>

              <Box display="flex" justifyContent="space-between" alignItems="center">
                <Typography
                  display="flex"
                  alignItems="center"
                  sx={{ gap: '8px', fontSize: '14px', fontWeight: '400', color: '#64748B', fontFamily: 'Manrope' }}
                >
                  Budget : <span style={{ fontSize: '18px', fontWeight: '500', color: '#1A1F36' }}>None</span>
                </Typography>
                <AvatarGroup />
              </Box>
              </a>
            </div>
           
          ))}
        </div>
      </div>
    </>
  );
};
export default ProjectsCard;
